import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", "px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-radius: 13px;\n      box-shadow: ", ";\n      padding: 0.4em 0.28em 0.28em;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  flex-shrink: 0;\n  height: ", ";\n  width: ", ";\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-grow: 1;\n  font-size: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { Icon, Image } from '@scp/ui-shared/theme/icons';
import { color, typography, property, size } from '@scp/ui-shared/theme/variables';
import { getCSSUnitValue } from '@scp/ui-shared/theme/utils';
var DEFAULT_SIZE = '2.58em';
var TEXT = {
  LOGO_TITLE: 'App logo'
};
var PROPS_TO_OMIT = ['fontSize', 'noMargin', 'bold'];
var Wrapper = styled(Paragraph).attrs({
  noMargin: true
})(_templateObject(), color.textPrimary, function (props) {
  return getCSSUnitValue(props.fontSize);
});
var IconComponent = withoutProps(Icon, ['widthValue', 'heightValue', 'withBoxWrapper']);
var LogoIcon = styled(IconComponent)(_templateObject2(), function (props) {
  return getCSSUnitValue(props.heightValue || DEFAULT_SIZE);
}, function (props) {
  return getCSSUnitValue(props.widthValue || DEFAULT_SIZE);
}, function (props) {
  return props.withBoxWrapper && css(_templateObject3(), color.background, property.boxShadow);
});
var Text = styled.span(_templateObject4(), function (props) {
  return props.withBoxWrapper ? size.gutterSmall : size.gutterSmall / 2;
});
/**
 * Branding logo component support all available icons
 *
 * @example ./__docs__/Logo.md
 */

export function Logo(_a) {
  var name = _a.name,
      url = _a.url,
      title = _a.title,
      _a$fontSize = _a.fontSize,
      fontSize = _a$fontSize === void 0 ? typography.defaultFontSize : _a$fontSize,
      width = _a.width,
      height = _a.height,
      _a$as = _a.as,
      as = _a$as === void 0 ? 'span' : _a$as,
      _a$treatAccessibility = _a.treatAccessibilityAsImage,
      treatAccessibilityAsImage = _a$treatAccessibility === void 0 ? true : _a$treatAccessibility,
      withBoxWrapper = _a.withBoxWrapper,
      otherProps = __rest(_a, ["name", "url", "title", "fontSize", "width", "height", "as", "treatAccessibilityAsImage", "withBoxWrapper"]);

  var renderLogo = function renderLogo() {
    if (url) {
      return React.createElement(Wrapper, Object.assign({
        as: withoutProps(as, PROPS_TO_OMIT),
        fontSize: fontSize
      }, otherProps), React.createElement(Image, {
        width: width,
        height: height || width,
        url: url,
        title: TEXT.LOGO_TITLE
      }), title && React.createElement(Text, {
        withBoxWrapper: withBoxWrapper
      }, title));
    }

    if (!name) {
      return null;
    }

    return React.createElement(Wrapper, Object.assign({
      as: withoutProps(as, PROPS_TO_OMIT),
      fontSize: fontSize
    }, otherProps), React.createElement(LogoIcon, {
      name: name,
      title: TEXT.LOGO_TITLE,
      widthValue: width,
      heightValue: height || width,
      isImage: treatAccessibilityAsImage,
      withBoxWrapper: withBoxWrapper
    }), title && React.createElement(Text, {
      withBoxWrapper: withBoxWrapper
    }, title));
  };

  return React.createElement(React.Fragment, null, renderLogo());
}